export const GET_SUBSCRIBER_COMMUNICATION_PREFERENCES_KEY =
  'lumos_communication_preferences';

export const PUT_SUBSCRIBER_COMMUNICATION_PREFERENCES_QUERY_KEY =
  'lumos_subscriber_communication_prefrence_put';
